import React from 'react';
import '../../../../../sass/apps/commerce/desktop/upgrade_information_content/ads_explained.scss';

const AdsExplained = (props) => (
  <div className="ads-explained">
    <h2>Early Bird Access & Bold Ads explained</h2>
    <p>
      SpareRoom is free to use. Anyone can post a Free Ad and contact all Bold
      Ads (blue), and other Free Ads (grey) more than 7 days old. To contact
      Free Ads less than 7 days old you
      {`'`}
      ll need to upgrade to get Early Bird Access. Upgraded users can also place
      Bold Ads, which are free for everyone to contact, appear higher up the
      results list and get (on average) double the {props.localisations.enquiries}.
    </p>
    <div className="compare">
      <h3>Free users</h3>
      <ul className="ads-explained__free">
        <li>
          <i className="fas fa-check ads-explained__check" /> Post an ad
        </li>
        <li>
          <i className="fas fa-check ads-explained__check" /> View all ads
        </li>
        <li>
          <i className="fas fa-check ads-explained__check" /> Contact all Bold
          Ads and all Free Ads (more than 7 days old)
        </li>
        <li className="not-available">
          <i className="far fa-times ads-explained__cross" /> Early Bird Access
          - (contact Free Ads less than 7 days old)
        </li>
        <li className="not-available">
          <i className="far fa-times ads-explained__cross" /> Post a Bold Ad -
          (stay higher in the listings and double your {props.localisations.enquiries})
        </li>
      </ul>
    </div>
    <div className="compare">
      <h3>Upgraded users</h3>
      <ul className="ads-explained__upgraded">
        <li>
          <i className="fas fa-check ads-explained__check" /> Post an ad
        </li>
        <li>
          <i className="fas fa-check ads-explained__check" /> View all ads
        </li>
        <li>
          <i className="fas fa-check ads-explained__check" /> Contact all Bold
          Ads and all Free Ads (more than 7 days old)
        </li>
        <li>
          <i className="fas fa-check ads-explained__check" /> Early Bird Access
          - (contact Free Ads less than 7 days old)
        </li>
        <li>
          <i className="fas fa-check ads-explained__check" /> Post a Bold Ad -
          (stay higher in the listings and double your {props.localisations.enquiries})
        </li>
      </ul>
    </div>
  </div>
);

export default AdsExplained;
